export default /^[1-9]\d{1,9}(-\d*)?$/;
